module.exports = __webpack_public_path__ + "static/p02_pollito-40211f6f059207d3a354702a2d6f053b.png";